import { GridValueFormatterParams } from '@mui/x-data-grid';
import { Translate } from 'react-admin';

export const formatOrigin = (
  params: GridValueFormatterParams<string>,
  translate: Translate
): string =>
  params.value ? translate(`positioning.origin.${params.value}`) : '-';
